import fetchPost from '@/api/http.js'

export default {
    actions: {
        getRecepListApi({}, data) {
            return fetchPost('/saas/receipt/queryPage', data)
        },
        writeReceipt({}, data) {
            return fetchPost('/saas/receipt/queryReceipt', data)
        },
        writeUnableBack({}, data) {
            return fetchPost('/saas/receipt/receiptUnableBack', data)
        },
        postReceiptSign({}, data) {
            return fetchPost('/saas/receipt/receiptSign', data)
        },
        postReject({}, data) {
            return fetchPost('/saas/receipt/reject', data)
        },
        // writeReceipt({}, data) {
        //     return fetchPost('/saas/receipt/queryReceipt', data)
        // },

    }
}
